export const externalRoutes = {
  cookiePolicy: 'https://www.wagl.golf/cookie-policy',
  privacyPolicy: 'https://www.wagl.golf/privacy',
  termsOfService: 'https://www.wagl.golf/terms-of-service'
};
